export * from "./enums";

export type * from "./betprocessor/bet.dto";
export type * from "./betprocessor/ticket.dto";

export type * from "./bonus/bonus.dto";
export type * from "./bonus/referral.dto";
export type * from "./bonus/referred.user.dto";

export type * from "./casino/bet.dto";
export type * from "./casino/enum.dto";
export type * from "./casino/favorite.dto";
export type * from "./casino/free.round.dto";
export type * from "./casino/game.dto";
export type * from "./casino/session.dto";

export type * from "./message/chat.dto";
export type * from "./message/message.dto";

export type * from "./payment/meta.dto";
export type * from "./payment/deposit.dto";
export type * from "./payment/withdrawal.dto";
export type * from "./payment/bankDetails.dto";
export type * from "./payment/cryptoDetails.dto";
export type * from "./payment/userAccount.dto";
export type * from "./payment/transaction.dto";

export type * from "./trading/scoreboard.dto";
export type * from "./trading/feed.dto";
export type * from "./trading/common.dto";
export type * from "./trading/sport.dto";
export type * from "./trading/category.dto";

export type * from "./user/login.dto";
export type * from "./user/recovery.dto";
export type * from "./user/profile.dto";
export type * from "./user/registration.dto";

export type * from "./wallet/wallet.dto";
export type * from "./wallet/transaction.dto";

export type * from "./config/config.dto";
export type * from "./config/bonus.dto";

export type * from "./crypto.dto";

export type * from "./cms/media.dto";
export type * from "./cms/popup.dto";
export type * from "./cms/banner.dto";
export type * from "./cms/banner.translations.dto";
export type * from "./cms/reel.dto";
export type * from "./cms/reel.translations.dto";
export type * from "./cms/user-interface.dto";
export type * from "./cms/notification.dto";

export type * from "./document/file.dto";
export type * from "./document/document.dto";

export type * from "./exchange/exchangeRates.dto";
